import { Controller, FieldValues, Path, PathValue } from "react-hook-form"

import { FormType, IFormInputControllerProps } from "@/shared/types"
import { decimalRules } from "@/shared/rules"

import { FormInput } from "@/shared/components"

export const DecimalController = <FieldsType extends FieldValues>({
  name,
  control,
  error,
  labelProps,
  disabled,
  description,
  placeholder,
  borderless,
  register,
  trigger,
  onBlurHandler,
  onChangeHandler,
}: IFormInputControllerProps<FieldsType>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <FormInput
            {...(register &&
              register(field.name, {
                ...decimalRules(!!labelProps?.required),
              }))}
            {...field}
            onBlur={(event) => {
              field.onChange(event?.target?.value.trim() as PathValue<FieldsType, Path<FieldsType>>)
              onBlurHandler && onBlurHandler()
              trigger && trigger(name)
            }}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "e" || event.key === "-" || event.key === "+" || event.key === ",") {
                event.preventDefault()
              }
            }}
            onChange={(event) => {
              const value = event?.target?.value
              const regex = /^\d+(\.\d)?$/

              if (regex.test(value) || value === "") {
                field.onChange(value as PathValue<FieldsType, Path<FieldsType>>)
              }
              onChangeHandler && onChangeHandler()
            }}
            id={name}
            label={description}
            labelProps={{ ...labelProps, hidden: true }}
            description={description}
            type={FormType.Number}
            title=""
            error={error}
            disabled={disabled}
            placeholder={placeholder}
            borderless={borderless}
          />
        )
      }}
    />
  )
}
